import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { API_URL } from "../../../config";
import { useSelector } from "react-redux";
import { Button, Form, Tab, Dropdown, Modal, Spinner } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { logoutonexpire } from "../../../store/actions/AuthActions";
import Pagination from "../common/Pagination";
import CampusDriveCard from "./CampusDriveCard";
import { setCourses } from "../../../store/actions/CourseAction";

const CampusDriveList = () => {
  const [campusDrives, setCampusDrives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [control4, setControl4] = useState("Passout Year");
  const [selectedCourse, setSelectedCourse] = useState("Course");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const collegeId = useSelector((state) => state.college_id.college_id);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [drive_id, setDriveId] = useState(null);
  const [remark, setRemark] = useState("");
  const courses = useSelector((state) => state.courses.courses);
  const itemsPerPage = 10;

  const filterOptionsStatus = [
    "All",
    "Draft",
    "Cancelled",
    "Published",
    "Closed",
  ];

  const sortOptions = [
    { index: null, value: "Passout Year" },
    { index: 0, value: moment().year() - 1 },
    { index: 1, value: moment().year() - 2 },
    { index: 2, value: moment().year() },
    { index: 3, value: moment().year() + 1 },
    { index: 4, value: moment().year() + 2 },
  ];

  const fetchCampusDrives = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;
    const formData = new FormData();

    formData.append("limit", itemsPerPage);
    formData.append("offset", currentPage * itemsPerPage);
    formData.append("college_id", collegeId);

    // Only append search if it has a non-empty value
    if (inputValue && inputValue.trim() !== "") {
      formData.append("search", inputValue.trim());
    }

    if (control4 !== "Passout Year") {
      formData.append("passout_year", control4);
    }

    if (selectedCourseId) {
      formData.append("course_id", selectedCourseId);
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/CampusDrive/get_campus_drive_jobs_post`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: authToken,
          },
        },
      );
      if (response.data.success) {
        setCampusDrives(response.data.data || []);
        setTotalRecord(response.data.totalRecords || 0);
      } else {
        setCampusDrives([]);
        setTotalRecord(0);
        toast.warning(
          response.data.message ??
            "Failed to fetch campus drives. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error fetching campus drives:", error);
      setCampusDrives([]);
      setTotalRecord(0);
      if (error?.response?.status === 401) {
        dispatch(logoutonexpire());
      }
      toast.warning("Internet appears Offline!! Please try again later");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = useCallback(() => {
    setCurrentPage(0);
    fetchCampusDrives();
  }, [inputValue]);

  const resetFilter = useCallback(() => {
    setInputValue("");
    setCurrentPage(0);
    setControl4("Passout Year");
    setSelectedCourse("Course");
    setSelectedCourseId(null);
    fetchCampusDrives();
  }, []);

  useEffect(() => {
    fetchCampusDrives();
  }, [control4, selectedCourseId, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const sendReport = (props) => {
    const params = new URLSearchParams();
    params.append("drive_id", props.drive_id);
    params.append("college_connect_id", collegeId);
    params.append("remark", props.remark);

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    if (props.remark.length === 0) {
      toast.error("Please enter a remark");
      return;
    }

    if (props.remark.length < 20) {
      toast.error("Remark must be at least 20 characters long.");
      return;
    }

    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/CampusDrive/report_drive`,
        params,
        {
          headers: {
            Authorization: authToken,
          },
        },
      )
      .then((res) => {
        setModalShow(false);
        setRemark("");
        toast.success("The campus drive has been reported successfully.");
        fetchCampusDrives();
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          dispatch(logoutonexpire());
        }
        toast.error(err?.response?.data?.message || "Failed to send report");
      });
  };

  const handleReport = (id) => {
    if (!id) {
      console.error("Drive ID cannot be blank");
      return;
    }
    setModalShow(true);
    setDriveId(parseInt(id));
    setRemark("");
  };

  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  return (
    <>
      <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
        <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {control4}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              {sortOptions?.map((option, index) => (
                <Dropdown.Item
                  key={index}
                  className="text-primary"
                  onClick={() => {
                    setControl4(option.value);
                    setCurrentPage(0);
                    fetchCampusDrives();
                  }}
                >
                  {option.value}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary justify-content-between d-flex align-items-center i-false"
            >
              {selectedCourse}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item
                className="text-primary"
                onClick={() => {
                  setSelectedCourse("Course");
                  setSelectedCourseId(null);
                  setCurrentPage(0);
                  fetchCampusDrives();
                }}
              >
                Course
              </Dropdown.Item>
              {courses?.map((course, index) => (
                <Dropdown.Item
                  key={index}
                  className="text-primary"
                  onClick={() => {
                    setSelectedCourse(course.name);
                    setSelectedCourseId(course?.filter_id);
                    setCurrentPage(0);
                  }}
                >
                  {course.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="col-xl-7 col-xxl-7 col-lg-7 col-12 d-md-flex job-title-search pe-0">
          <div className="input-group search-area">
            <input
              type="text"
              value={inputValue}
              className="form-control h-auto"
              placeholder="search campus drive title here..."
              onChange={(e) => setInputValue(e.target.value)}
            />
            <span className="input-group-text">
              <Button onClick={handleSearch} className="btn btn-primary btn-sm">
                Search<i className="flaticon-381-search-2 ms-1" style={{ fontSize: '14px', verticalAlign: 'middle' }}></i>
              </Button>
            </span>
          </div>
        </div>
        <div className="col-xl-1 col-xxl-1 col-lg-1 col-12 d-flex align-items-center justify-content-lg-end justify-content-center">
          <button onClick={resetFilter} className="btn btn-danger btn-sm">
            Reset
          </button>
        </div>
      </div>

      <div className="mb-4">
        <div
          className="d-flex align-items-center"
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            width: "fit-content",
          }}
        >
          {/* <div className="btn-group" role="group" style={{ gap: 3 }}>
            {filterOptionsStatus.map((filter) => (
              <button
                key={filter}
                className="btn btn-md"
                style={
                  control4.toLowerCase() === filter.toLowerCase()
                    ? {
                        backgroundColor: "#1966ff",
                        borderRadius: "10px",
                        color: "white",
                        fontWeight: "bold",
                      }
                    : {
                        backgroundColor: "white",
                        borderRadius: "10px",
                      }
                }
                onClick={() => {
                  setActiveFilter(
                    filter.toLowerCase() === "published"
                      ? "open"
                      : filter.toLowerCase()
                  );
                  fetchCampusDrives(
                    filter.toLowerCase() === "published"
                      ? "open"
                      : filter.toLowerCase()
                  );
                }}
              >
                {filter}
              </button>
            ))}
          </div> */}
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading campus drives...</p>
        </div>
      ) : campusDrives && campusDrives.length > 0 ? (
        <Tab.Container defaultActiveKey="Boxed">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="mb-4">
              <h5>
                Showing {currentPage * itemsPerPage + 1} to{" "}
                {Math.min((currentPage + 1) * itemsPerPage, totalRecord)} of{" "}
                {totalRecord}{" "}
              </h5>
              <span>Based your preferences</span>
            </div>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="Boxed">
              <div className="row">
                {campusDrives.map((drive, index) => {
                  return (
                    <CampusDriveCard
                      drive={drive}
                      handleReport={handleReport}
                      key={index}
                    />
                  );
                })}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={Math.ceil(totalRecord / itemsPerPage)}
                totalRecord={totalRecord}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      ) : (
        <div className="text-center py-5 bg-white rounded shadow-sm">
          <i className="fa fa-search fa-3x text-muted mb-3"></i>
          <h4>No campus drives found</h4>
          <p className="text-muted">Try adjusting your search criteria</p>
        </div>
      )}

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Report Campus Drive
          </Modal.Title>
          <Button
            onClick={() => setModalShow(false)}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form.Control
            as={"textarea"}
            rows={3}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            className=""
            id="exampleFormControlTextarea1"
            placeholder="Write here..."
            style={{ height: "100px", border: "1px solid #cccccc" }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)} variant="danger light">
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              sendReport({
                drive_id,
                remark,
              })
            }
          >
            Report Drive
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CampusDriveList;
